import {
  Box,
  FormControlLabel,
  Paper,
  Stack,
  Switch,
  Typography,
} from '@mui/material'
import { tsGetAnimalsInContainer } from '../../../../Typescript/API_Response'
import AnimalButton from '../Buttons/AnimalButton'
import { stackGap } from '../../../../Constants&Theme/Spacing'
import { UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'

function ContainerCard({
  containerQuery,
  toggleCollect,
  animals,
  index,
}: {
  containerQuery: UseQueryResult<
    tsGetAnimalsInContainer,
    AxiosResponse<any, any>
  >
  toggleCollect: any
  animals: any
  index: number
}) {
  const fontSize = 16
  return (
    <Paper
      elevation={3}
      key={index}
      sx={{ width: 1, p: 2, display: 'flex', flexDirection: 'column' }}
    >
      <Stack
        direction={'row'}
        gap={stackGap.row}
        sx={{ width: 1, display: 'flex' }}
      >
        <Box sx={{ display: 'flex', width: 1 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 'bold', fontSize }}
          >
            Zone Name:&nbsp;
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize }}
          >
            {containerQuery?.data?.container?.ZoneName}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', width: 1 }}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 'bold', fontSize }}
          >
            Owner Name:&nbsp;
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize }}
          >
            {containerQuery?.data?.container?.OwnerName}
          </Typography>
        </Box>
      </Stack>
      {(containerQuery?.data?.animals ?? []).map((animal) => (
        <Box
          key={animal.UAI!}
          sx={{ display: 'flex', mt: 1 }}
        >
          <AnimalButton animal={animal} />
          <Box
            sx={{
              display: 'flex',
              width: 1 / 4,
              justifyContent: 'flex-end',
              flexDirection: 'column',
              ml: 2,
            }}
          >
            <FormControlLabel
              style={{
                display: 'inline-block',
                justifyContent: 'flex-start',
                textAlign: 'left',
                flex: 1,
                width: '30%',
              }}
              control={
                <Switch
                  checked={animals[animal.UAI!] || false}
                  onChange={toggleCollect}
                  name={String(animal.UAI!)}
                  color="primary"
                  inputProps={{ tabIndex: -1 }}
                />
              }
              labelPlacement="start"
              label="Collect"
            />
          </Box>
        </Box>
      ))}
    </Paper>
  )
}

export default ContainerCard
